module.exports = " <typeahead class=\"global-search flex-1\" :src=\"cp_url('search/perform')\" :limit=10 :reset-on-blur=true @selected=selected></typeahead> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/typeahead/SearchTypeahead.vue
// module id = 402
// module chunks = 0